<template>
    <div>
        <div class="row my-3">
            <h1 class="col-sm-12">Aclaraciones</h1>
        </div>

        <DataGrid :configuracion="datagrid_config" :data="aclaraciones" @ready="buscar_btns">
            <button class="btn btn-secondary mr-2" @click="obtener_aclaraciones"><i class="fa-solid fa-rotate"></i>
                Actualizar</button>
            <button class="btn btn-primary" @click="show_modal = true"><i class="fa-solid fa-plus"></i> Crear</button>
        </DataGrid>

        <formulario-aclaracion v-if="show_modal" :prop_aclaracion="aclaracion" @close="cerrar_modal" @update="cerrar_modal(true)" />

    </div>
</template>

<script>
import DataGrid from '@/components/DataGridV3.vue';
import apiCondusefAclaraciones from '@/apps/condusef/api/aclaraciones';
import FormularioAclaracion from "@/apps/condusef/pages/Aclaraciones/FormularioAclaracion.vue";

export default {
    components: { DataGrid, FormularioAclaracion },
    data() {
        return {
            datagrid_config: {
                cols: {
                    folio_condusef: 'Folio Condusef',
                    folio_atencion: 'Folio Atención',
                    trimestre_label: 'Trimestre',
                    estatus_aclaracion: 'Estatus',
                    created_at: 'Fecha Creación',
                    otros: '',
                },
                mutators: {
                  folio_atencion(val, row, vue) {

                    return val && val.length && val.length > 15 ? val.substr(0, 15) + '...' : val;
                  },
                  estatus_aclaracion(val, row, vue) {
                    return "<span class='" + (val == 1 ? 'badge badge-warning' : 'badge badge-success') + "'>" + (val == 1 ? 'Pendiente' : 'Concluido') + "</span>";
                  },
                  created_at(val, row, vue) {
                    return vue.$moment(val).format('YYYY-MM-DD HH:SS:DD');
                  },
                  otros(val, row, vue) {
                    return '<button class="btn btn-secondary btn-accion" data-aclaracion="' + vue.$helper.toJson(row) + '"><i class="fa-regular fa-eye"></i></button>'
                  }
                },
                selector: false,
            },
            aclaraciones: [],
            aclaracion: {
              folio_atencion: null
            },
            show_modal: false,
        }
    },
    mounted() {
        this.obtener_aclaraciones();
    },
    methods: {
        async obtener_aclaraciones() {
            try {
                this.aclaraciones = (await apiCondusefAclaraciones.listar()).data;
            } catch (error) {
                this.$log.error('error', error);
                this.$helper.showAxiosError(error, 'Error');
            }
        },
        buscar_btns() {
            document.querySelectorAll('button.btn-accion').forEach(btn => {
                btn.removeEventListener('click', this.abrir_modal);
                btn.addEventListener('click', this.abrir_modal);
            })
        },
        abrir_modal(event) {
            let btn = event.target;

            if (btn.tagName == 'I')
                btn = btn.parentElement;

            this.aclaracion = this.$helper.fromJson(btn.dataset.aclaracion);

            this.show_modal = true;
        },
        cerrar_modal(recargar) {
            if (typeof recargar == ' undefined')
                recargar = false

            this.show_modal = false;
            this.aclaracion = { folio_atencion: null }

            if (recargar)
                this.obtener_aclaraciones();

        }

    },

}
</script>